import type { Prototype } from "../prototype-types";

export const kevinLaiPrototypes: Prototype[] = [
  {
    id: "homepage-q226",
    name: "Homepage Q2'26",
    path: "/homepage-q226",
    description:
      "Homepage redesign exploration for Q2 2026 with updated discovery product tiles and layout variants.",
    owner: "Kevin Lai",
    createdAt: "2026-04-03",
    lastUpdated: "2026-04-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e3af65c7d23006264da4248399d66e73ba1b76aa4c360eb73ce3aa446e1b07f4.png",
    creationTool: "cursor",
  },
  {
    id: "logged-out-nav",
    name: "Logged out Nav",
    path: "",
    externalUrl: "https://dense-city-49631446.figma.site",
    description: "Insider enrollment flow: Payment transparency prototype",
    owner: "Kevin",
    createdAt: "2026-02-12",
    lastUpdated: "2026-02-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/12162c26a403e4a7ba5cc709a4b8b568ff1dde648088b2b8196f9a9bad5cba18.png",
    creationTool: "figma-make",
  },
  {
    id: "wizard-survey-sign-up-modal",
    name: "Wizard survey sign-up modal",
    path: "",
    externalUrl: "https://wired-dried-12346174.figma.site/",
    description:
      "- Adds V7 variant to Upmarket+ Retailer Landing Page prototype - Updates all sections to match Figma design specs exactly - Hero section with 4 positi",
    owner: "Kevin",
    createdAt: "2026-01-27",
    lastUpdated: "2026-02-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/bfd623937c08568d3fec4e8207860e5beea760955bbd22743d5e5e6cfb9d4ef2.png",
    creationTool: "figma-make",
  },
  {
    id: "brand-page-logged-out",
    name: "Brand Page (Logged Out)",
    path: "/brand/driftless-studios/logged-out",
    description:
      "Brand page for logged-out retailers. Features headless navigation, brand info, product filtering, and search.",
    owner: "Kevin",
    createdAt: "2025-12-03",
    lastUpdated: "2025-11-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d0e2706d94c7eea8b69409fc85f52acbff94c1288c6928315dfa6e38d2f0ff7f.png",
    project: "Logged Out Brand Pages",
    creationTool: "cursor",
  },
  {
    id: "brand-page-logged-out-viverano",
    name: "Brand Page (Logged Out) - Viverano Organics",
    path: "/brand/viverano-organics/logged-out",
    description:
      "Brand page for Viverano Organics with three variants (V1, V2, V3). Features headless navigation, brand info, product filtering, and email capture modal.",
    owner: "Kevin",
    createdAt: "2025-12-13",
    lastUpdated: "2025-11-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5574a3c1e0abc925fd855c4cb23c41be0f4d8736f3586b003e06e47046022865.png",
    project: "Logged Out Brand Pages",
    creationTool: "cursor",
  },
  {
    id: "brand-page-logged-out-caden-lane",
    name: "Brand Page (Logged Out) - Caden Lane",
    path: "/brand/caden-lane/logged-out",
    description:
      "Brand page for Caden Lane with three variants (V1, V2, V3). Features headless navigation, brand info, product filtering, and email capture modal.",
    owner: "Kevin",
    createdAt: "2025-12-15",
    lastUpdated: "2025-11-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ca7b0c2e71ba60ce3178d4982a6bc37d90fefee579c3dac2a7a9abdc9e8f22d5.png",
    project: "Logged Out Brand Pages",
    creationTool: "cursor",
  },
  {
    id: "brand-page-logged-out-toysmith",
    name: "Brand Page (Logged Out) - Toysmith",
    path: "/brand/toysmith/logged-out",
    description:
      "Brand page for Toysmith with three variants (V1, V2, V3). Features headless navigation, brand info, product filtering, and email capture modal.",
    owner: "Kevin",
    createdAt: "2025-12-15",
    lastUpdated: "2025-11-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f9c1e2bd802175830c8ef7c92da89e461b51e584ab019a780be92b851e9a3b70.png",
    project: "Logged Out Brand Pages",
    creationTool: "cursor",
  },
  {
    id: "brand-page-logged-out-sweet-wink",
    name: "Brand Page (Logged Out) - Sweet Wink",
    path: "/brand/sweet-wink/logged-out",
    description:
      "Brand page for Sweet Wink with three variants (V1, V2, V3). Features headless navigation, brand info, product filtering, and email capture modal.",
    owner: "Kevin",
    createdAt: "2025-12-15",
    lastUpdated: "2025-11-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/66dcc378061f0b9e78f3f63beab0188cf9198c928d561aaa195dfd6d1d679df1.png",
    project: "Logged Out Brand Pages",
    creationTool: "cursor",
  },
  {
    id: "logged-out-personalization",
    name: "Logged out personalization",
    path: "/logged-out-personalization",
    description:
      "Prototype exploring personalization experiences for logged-out retailers.",
    owner: "Kevin",
    project: "Logged Out Personalization",
    createdAt: "2026-02-28",
    lastUpdated: "2026-03-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/26c031d2bfb9d5560d0502cb9ce12e54acebde0250109594da26d78b077f0f5e.png",
    creationTool: "cursor",
  },
  {
    id: "onboarding",
    name: "Onboarding - Upmarket",
    path: "/onboarding",
    description: "Prototype for onboarding flow.",
    owner: "Kevin",
    project: "Terms loader",
    createdAt: "2026-01-16",
    lastUpdated: "2026-01-16",
    surfaceArea: "Other",
    category: "experimental",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/781a7a0369fbc5f6e9f240b6947a72e8e8220c337b3e76ed46f938d7a088e614.png",
    creationTool: "cursor",
  },
  {
    id: "fdxp-checkout",
    name: "FDXP Checkout",
    path: "/fdxp-checkout",
    description: "Checkout flow with business details form and order summary.",
    owner: "Kevin",
    project: "Terms loader",
    createdAt: "2026-01-16",
    lastUpdated: "2026-03-04",
    surfaceArea: "Other",
    category: "experimental",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e13b59e294560367f3c9e79af16e46cf25e148b05bef733cd81737ead928b075.png",
    creationTool: "cursor",
  },
  {
    id: "kl-packing-slip-printing",
    name: "Brand Order Detail - Packing Slip Printing",
    path: "/kl/packing-slip-printing",
    description: "UX iteration on brand order detail page focused on packing slip printing experience.",
    owner: "Kevin Lai",
    createdAt: "2026-05-08",
    lastUpdated: "2026-05-08",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/be1f291a8f3bab7c90e81f2ba6a3542d0cbd3249be6c9f4edf78ef3e3215e1c3.png",
    creationTool: "claude-code",
  },
  {
    id: "kl-landed-cost-checkout",
    name: "Landed Cost in Checkout",
    path: "/kl/landed-cost-checkout",
    description: "",
    owner: "Kevin Lai",
    createdAt: "2026-06-08",
    lastUpdated: "2026-06-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/kl-landed-cost-checkout.png",
    creationTool: "claude-code",
  }
];
